import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Circle, Path, Rect, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import { getPaymentBadgeColors } from './paymentBadgeColors';

export interface BnplIconProps extends SvgProps {
  width?: number;
  height?: number;
  selected?: boolean;
}

const BnplIcon: React.FC<BnplIconProps> = ({
  width = 38,
  height = 24,
  selected = false,
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  const { background, foreground } = getPaymentBadgeColors(selected);

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 38 24"
      fill="none"
      {...props}
    >
      <Rect height="24" rx="3" width="38" fill={colors[background]} />
      <Path
        d="M26 10.6V15.4453C26 16.7477 25.4931 17.3993 24.4697 17.3994H13.5303C12.5117 17.3993 12 16.7478 12 15.4453V10.6H26ZM13.9932 13.0557C13.7059 13.0559 13.5158 13.3021 13.5156 13.6621V14.832C13.5156 15.186 13.7058 15.4392 13.9932 15.4395H15.1875C15.4751 15.4395 15.665 15.1861 15.665 14.832V13.6621C15.6649 13.3019 15.475 13.0557 15.1875 13.0557H13.9932ZM24.4697 6.59961C25.493 6.59976 25.9999 7.25729 26 8.55957V9.14746H12V8.55957C12.0001 7.25725 12.5118 6.59971 13.5303 6.59961H24.4697Z"
        fill={colors[foreground]}
      />
      <Circle cx="25" cy="14.5" r="5" fill={colors[background]} />
      <Path
        d="M25 10.5C24.2089 10.5 23.4355 10.7346 22.7777 11.1741C22.1199 11.6136 21.6072 12.2384 21.3045 12.9693C21.0017 13.7002 20.9225 14.5044 21.0769 15.2804C21.2312 16.0563 21.6122 16.769 22.1716 17.3284C22.731 17.8878 23.4437 18.2688 24.2196 18.4231C24.9956 18.5775 25.7998 18.4983 26.5307 18.1955C27.2616 17.8928 27.8864 17.3801 28.3259 16.7223C28.7654 16.0645 29 15.2911 29 14.5C28.9989 13.4395 28.5771 12.4227 27.8272 11.6728C27.0773 10.9229 26.0605 10.5011 25 10.5ZM27.1538 14.8077H25C24.9184 14.8077 24.8401 14.7753 24.7824 14.7176C24.7247 14.6599 24.6923 14.5816 24.6923 14.5V12.3462C24.6923 12.2645 24.7247 12.1863 24.7824 12.1286C24.8401 12.0709 24.9184 12.0385 25 12.0385C25.0816 12.0385 25.1599 12.0709 25.2176 12.1286C25.2753 12.1863 25.3077 12.2645 25.3077 12.3462V14.1923H27.1538C27.2355 14.1923 27.3137 14.2247 27.3714 14.2824C27.4291 14.3401 27.4615 14.4184 27.4615 14.5C27.4615 14.5816 27.4291 14.6599 27.3714 14.7176C27.3137 14.7753 27.2355 14.8077 27.1538 14.8077Z"
        fill={colors[foreground]}
      />
    </Svg>
  );
};

BnplIcon.displayName = 'BnplIcon';
export { BnplIcon };
